"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/user-disclaimer.svg.js",
    _path;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _path || (_path = React.createElement("path", {
    d: "M44.463 41.732c.094.492.008.958-.257 1.398-.265.44-.632.712-1.1.817a.93.93 0 01-.328.053c-.374 0-.717-.15-1.03-.448a2.115 2.115 0 01-.608-1.134c-.25-1.512-.905-2.76-1.966-3.745-1.06-.984-2.285-1.477-3.674-1.477-1.389 0-2.613.493-3.674 1.477-1.061.985-1.717 2.233-1.966 3.745-.094.527-.328.94-.702 1.24a1.428 1.428 0 01-1.264.29c-.468-.106-.835-.379-1.1-.818a1.925 1.925 0 01-.257-1.398c.312-1.758.96-3.305 1.942-4.641.983-1.336 2.192-2.32 3.628-2.954-.874-.633-1.56-1.468-2.06-2.505a7.505 7.505 0 01-.749-3.296c0-1.934.677-3.43 1.904-4.652C32.43 22.462 33.782 22 35.5 22s3.062.55 4.225 1.684c1.163 1.134 1.93 2.718 1.93 4.652 0 1.195-.242 2.303-.725 3.322a6.374 6.374 0 01-2.037 2.48c1.436.632 2.645 1.617 3.628 2.953.983 1.336 1.63 2.883 1.942 4.641zM33.35 26.9c-.567.567-.85 1.267-.85 2.1 0 .833.292 1.542.875 2.125a2.864 2.864 0 002.1.875c.817 0 1.525-.292 2.125-.875.6-.583.9-1.292.9-2.125s-.3-1.542-.9-2.125C37 26.292 36.292 26 35.475 26s-1.525.3-2.125.9zM40.964 0c.982 0 1.817.344 2.505 1.031.687.688 1.031 1.523 1.031 2.505v16.696c0 .491-.172.909-.516 1.252a1.676 1.676 0 01-1.227.516c-.475 0-.892-.172-1.253-.516a1.667 1.667 0 01-.54-1.252V3.536H4.036v36.928h13.553c.491 0 .909.172 1.253.516.343.344.515.761.515 1.252s-.172.909-.515 1.252a1.705 1.705 0 01-1.253.516H4.036c-.982 0-1.817-.344-2.505-1.031C.844 42.28.5 41.446.5 40.464V3.536c0-.982.344-1.817 1.031-2.505C2.22.344 3.054 0 4.036 0h36.928zM8.188 14c-.438 0-.829-.194-1.172-.583-.344-.39-.516-.861-.516-1.417s.172-1.028.516-1.417c.343-.389.734-.583 1.171-.583h14.626c.468 0 .867.194 1.195.583.328.39.492.861.492 1.417s-.164 1.028-.492 1.417c-.328.389-.727.583-1.195.583H8.188zm8.624 5c.47 0 .868.194 1.196.583.328.39.492.861.492 1.417s-.164 1.028-.492 1.417c-.328.389-.727.583-1.195.583H8.188c-.438 0-.829-.194-1.172-.583-.344-.39-.516-.861-.516-1.417s.172-1.028.516-1.417c.343-.389.734-.583 1.171-.583h8.626zm0 9c.47 0 .868.194 1.196.583.328.39.492.861.492 1.417s-.164 1.028-.492 1.417c-.328.389-.727.583-1.195.583H8.188c-.438 0-.829-.194-1.172-.583-.344-.39-.516-.861-.516-1.417s.172-1.028.516-1.417c.343-.389.734-.583 1.171-.583h8.626z",
    fill: "none",
    fillRule: "evenodd",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: this
  })));
}

var _default = ReactComponent;
exports["default"] = _default;